import { Button, Modal, Text } from '@nimbus-ds/components';
import { Trans } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { useUnlinkPartner } from './hooks';

interface UnlinkPartnerModalProps {
  isOpen: boolean;
  onClose: () => void;
  partnerName: string;
  partnerEmail: string;
}

function UnlinkPartnerModal({
  isOpen,
  onClose,
  partnerName,
  partnerEmail,
}: Readonly<UnlinkPartnerModalProps>) {
  const { executeUnlink, isLoading } = useUnlinkPartner(onClose);
  const t = useTranslationConfigurations('partnersListComponent');

  return (
    <Modal open={isOpen} onDismiss={onClose}>
      <Modal.Header title={t('unlinkPartnerModal.title')} />
      <Modal.Body>
        <Text>
          <Trans
            ns={Domain.CONFIGURATIONS}
            i18nKey="partnersListComponent.unlinkPartnerModal.body"
            components={{
              strong: <strong />,
            }}
            values={{
              partnerName,
              partnerEmail,
            }}
          />
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} disabled={isLoading}>
          {t('unlinkPartnerModal.cancel')}
        </Button>
        <Button
          appearance="danger"
          onClick={executeUnlink}
          disabled={isLoading}
        >
          {t('unlinkPartnerModal.unlink')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UnlinkPartnerModal;
